/**
 * Persistence Service for FF Arena
 * Handles saving and restoring app state to/from localStorage
 */

const STORAGE_KEY = 'ff_arena_app_state';

/**
 * Save the current app state
 * @param {string} routeName - Current route path
 * @param {object} params - Route parameters
 * @param {object} uiState - Specific UI state (modals, inputs, etc.)
 */
export const saveAppState = (routeName, params = {}, uiState = {}) => {
    try {
        const state = {
            route: routeName,
            params: params,
            ui: {
                ...uiState,
                scrollY: window.scrollY,
                timestamp: Date.now()
            }
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
        console.error('Failed to save app state:', error);
    }
};

/**
 * Load the last saved app state
 * @returns {object|null}
 */
export const loadAppState = () => {
    try {
        const savedState = localStorage.getItem(STORAGE_KEY);
        if (!savedState) return null;
        return JSON.parse(savedState);
    } catch (error) {
        console.error('Failed to load app state:', error);
        return null;
    }
};

/**
 * Clear the saved app state
 */
export const clearAppState = () => {
    localStorage.removeItem(STORAGE_KEY);
};

/**
 * Update only the UI state part of the saved app state
 * Useful for periodic saves (e.g., every 1 second)
 * @param {object} uiState 
 */
export const updateUIState = (uiState) => {
    const currentState = loadAppState();
    if (currentState) {
        currentState.ui = {
            ...currentState.ui,
            ...uiState,
            scrollY: window.scrollY,
            timestamp: Date.now()
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(currentState));
    }
};

/**
 * Restore scroll position from saved state
 */
export const restoreScrollPosition = () => {
    const state = loadAppState();
    if (state && state.ui && typeof state.ui.scrollY === 'number') {
        window.scrollTo(0, state.ui.scrollY);
    }
};
